import "./App.css";
import axios from "axios";
import ReactPlayer from "react-player/file";
import { useQuery, QueryClient, QueryClientProvider } from "react-query";
import { useHash } from "react-use";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const queryClient = new QueryClient();
// generate a unique session ID for this user
const sessionId = uuidv4();


function App() {
  const [channelId] = useHash();

  return (
    <QueryClientProvider client={queryClient}>
      <Player channelId={channelId} />
    </QueryClientProvider>
  );
}

async function getStreamInfo(channelId) {
  var query = "";
  // streamUrlKey for exact video
  var queryString = "";
  if (channelId.indexOf("?") >= 0) {
    query = channelId.substring(channelId.indexOf("?") + 1);
    queryString = `&${query}`;
  }
  var urlBase = "https://api.godresource.com";
  var url = `${urlBase}/api/Streams/Latest?sessionId=${encodeURI(
    sessionId
  )}&channelName=${
    channelId.replace(query, "").replace(/\W/g, "") + queryString
  }`;
  const { data } = await axios.get(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "Access-Control-Max-Age": 600,
    },
  });
  return data;
}

function useStreamInfo(channelId) {
  return useQuery(["streamInfo", channelId], () => getStreamInfo(channelId), {
    enabled: !!channelId,
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
  });
}

function Player({ channelId }) {
  const { data } = useStreamInfo(channelId);
  const [streamUrl, setStreamUrl] = useState();
  // parse query string from channelId
  var query = "";
  if (channelId && channelId.indexOf("?") >= 0) {
    query = channelId.substring(channelId.indexOf("?") + 1);
  }
  // check if showDetails=1 is in the query string
  // default to false
  // example: #channelName?showDetails=1
  const showDetails = query.indexOf("showDetails=1") >= 0;

  useEffect(
    (streamUrl) => {
      if (data && data.streamUrl !== streamUrl) {
        // only update stream URL when changed.
        setStreamUrl(data.streamUrl);
      }
    },
    [data]
  );

  return (
    <div className="embed-container">
      <div className="player-wrapper">
        <ReactPlayer
          className="react-player"
          url={streamUrl}
          controls={true}
          width="100%"
          height="100%"
        />
      </div>
      {data && showDetails && (
        <div className="views-block">
          <div className="view-counter">
            {/* show view count formatted with commas */}
            <span className="view-count">
              {data.views.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>{" "}
            views
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
